module.exports = __webpack_public_path__ + "static/media/add off game.2fcefb54.svg";